import { action, observable, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Collapse} from 'reactstrap';

@observer
export class CollapsibleMenu extends React.Component<{
  label: string;
  icon?: string;
}> {
  @observable
  isOpen = true;

  @action
  toggle = () => {
    this.isOpen = !this.isOpen;
  };

  constructor(
    props: {
      label: string;
      icon?: string;
    }
  ) {
    super(props);
    makeObservable(this);
  }

  render() {
    const {icon, label, children} = this.props;
    return (
      <div className="sidebar-menu">
        <div className="sidebar-menu-header">
          <a className="side-menu-head" onClick={this.toggle}>
            {icon && <span className={icon}/>}
            {label}
          </a>
        </div>
        <Collapse isOpen={this.isOpen}>
          {
            children
          }
        </Collapse>
      </div>);
  }
}
